import { Component, OnInit } from '@angular/core';
import { AmbitService } from '../ambit.service';
import * as firebase from 'firebase';
import { Router } from '@angular/router';

@Component({
  selector: 'app-trips',
  templateUrl: './trips.component.html',
  styleUrls: ['./trips.component.css']
})
export class TripsComponent implements OnInit {

  public filterStatus:any = 'All';
  public searchQuery:any ;
  public searchList: any = ['driverName','driverEmail'];
  public sortColumn:any = 'driverName';
  public sortType:boolean = false ;

  constructor(public service: AmbitService,
    public router: Router) { 
    if(this.service.adminUser.userAccess.trips =='None') {
      this.router.navigate(['/home']);
    }
    if(!service.allTrips.length) {
      service.getAllTripsData() ;
    }

   }

  ngOnInit() {
  }

  toggleSortValue(val) {
    if(this.sortColumn==val){
      this.sortType = !this.sortType ;
    } else {
      this.sortColumn = val;
    }
  }

  onChangeStatus() {
    this.service.filteredTrips = [];
    if(this.filterStatus=='All') {
      this.service.filteredTrips = this.service.allTrips ;
    } else {
      for(var i=0; i<this.service.allTrips.length; i++ ) {
        if(this.filterStatus == this.service.allTrips[i].status || (this.filterStatus=='Pending' && !this.service.allTrips[i].status)) {
          this.service.filteredTrips.push(this.service.allTrips[i]);
        }
      }
    }
  }

}